import {Component, OnInit} from '@angular/core';
import {NgIf} from "@angular/common";
import {ErrorPanelComponent} from "../../../core/error-panel/error-panel.component";
import {ApiService} from "../../../services/api.service";
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {StorageService} from "../../../services/storage.service";
import {AuthConstants, ExternalLogonProviderState} from "../../shared";

@Component({
  selector: 'app-auth-external-google',
  standalone: true,
  imports: [
    NgIf,
    ErrorPanelComponent
  ],
  templateUrl: './auth-external-google.component.html',
  styleUrl: './auth-external-google.component.sass',
})
export class AuthExternalGoogleComponent implements OnInit {

  providerState: ExternalLogonProviderState | null
  gState?: string
  gExpires?: number
  error?: any
  elapsed = -1

  constructor(
    readonly api: ApiService,
    readonly auth: AuthService,
    readonly router: Router,
    private store: StorageService) {
    this.providerState = this.store.getItem<ExternalLogonProviderState>(
      AuthConstants.storageKeys.externalIdentityProviders.gState
    )
    if (this.providerState) {
      this.gState = `${this.providerState.state}`
      this.gExpires = this.providerState.createdAt
      this.elapsed = (Date.now() - this.gExpires) / 1000
    }
  }

  ngOnInit(): void {
    if (!this.gState) {
      this.error = "[Error 9691] Invalid authentication state."
    }
    else if (this.elapsed < 0 || this.elapsed > 60) {
      this.error = "[Error 9695] Stale authentication state. Elapsed is [" + this.elapsed + "]"
    }
    else {
      this.api.exchange(this.gState!).subscribe({
        next: (tokenResult) => {
          this.auth.loadIdentity(tokenResult).subscribe({
            next: () => {
              this.router.navigateByUrl('/')
                .catch(e => {
                  console.error(e)
                })
                .finally(() => {})
            },
            error: (identityError) => {
              console.error('Failed to load identity', this.gState, identityError)
              this.error = identityError
            }
          })
        },
        error: (exchangeError) => {
          console.error('Failed to exchange state', this.gState, exchangeError)
          this.error = exchangeError
        }
      })
    }
  }
}
